"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueCustomAttributesApi = void 0;
var _migrationHelpers = require("../util/migrationHelpers");
var _constants = require("../constants");
var _endpointHelpers = require("../util/endpointHelpers");
var _queryClientUtils = require("../util/queryClientUtils");
const IssueCustomAttributesApi = exports.IssueCustomAttributesApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    getAll: () => api.getAll("issue-attribute-definitions?limit=9999"),
    create: attributes => api.create("issue-attribute-definitions", attributes),
    update: (attributeDefinitionId, attributes) => api.update("issue-attribute-definitions/".concat(attributeDefinitionId), attributes),
    delete: attributeDefinitionId => api.delete("issue-attribute-definitions/".concat(attributeDefinitionId)),
    Mappings: {
      getAll: () => api.getAll("issue-attribute-mappings?limit=9999").then((0, _endpointHelpers.mapResults)(_migrationHelpers.IssueCustomAttributeMappingMigration.deserialize)),
      create: attributes => api.create("issue-attribute-mappings", attributes).then(_migrationHelpers.IssueCustomAttributeMappingMigration.deserialize),
      update: (attributeMappingId, attributes) => api.update("issue-attribute-mappings/".concat(attributeMappingId), _migrationHelpers.IssueCustomAttributeMappingMigration.serialize(attributes)).then(_migrationHelpers.IssueCustomAttributeMappingMigration.deserialize),
      delete: attributeMappingId => api.delete("issue-attribute-mappings/".concat(attributeMappingId)),
      /**
       * Replaces all mappings for the provided type/category/project with the provided mappings.
       */
      set: payload => api.request("issue-attribute-mappings", _constants.HttpMethod.Put, _migrationHelpers.IssueCustomAttributeBatchMigration.serialize(payload)).then(_migrationHelpers.IssueCustomAttributeBatchMigration.deserialize)
    }
  };
}, {
  invalidateByQueryKeys: () => _queryClientUtils.INVALIDATE_ALL_QUERIES
});
//# sourceMappingURL=IssueCustomAttributesApi.js.map